const doesNodeContainClick = (node, event) => node && node.contains(event.target);

export default doesNodeContainClick;
